// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cJ","reportCardBox":"cJ","report-img-wrap":"cK","reportImgWrap":"cK","report-title":"cL","reportTitle":"cL","report-date":"cM","reportDate":"cM"};